/**
 * Homepage: light header (white logo/links) while the Coeur hero is behind the header;
 * restores default dark Coeur header after scrolling past the hero. The same
 * past-hero check also shrinks the header (wordmark, menu icon, header bar height)
 * via the template-index--header-shrink class.
 */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  const LIGHT = 'template-index--header-light';
  const SHRINK = 'template-index--header-shrink';

  function headerBandBottom() {
    const group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return 0;
    return Math.ceil(group.getBoundingClientRect().bottom);
  }

  function update() {
    const hero = document.querySelector('.coeur-home-landing');
    if (!hero) {
      document.body.classList.remove(LIGHT);
      document.body.classList.remove(SHRINK);
      return;
    }
    const bottom = hero.getBoundingClientRect().bottom;
    const threshold = headerBandBottom() + 2;
    const pastHero = bottom <= threshold;
    document.body.classList.toggle(LIGHT, !pastHero);
    document.body.classList.toggle(SHRINK, pastHero);
  }

  let scheduled = false;
  function onScrollOrResize() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(update));
})();
